import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { ZariContext } from '_zari/context'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const IdProvinciaFormGroup = ({
  values,
  setValues,
  handleChange,
  idDepartamento,
  iError,
  iTouched,
  fIsSubmitting
}) => {
  const __zariContext = React.useContext(ZariContext)
  const [provincias, setProvincias] = React.useState([])

  React.useEffect(() => {
    setProvincias([])
    if (idDepartamento !== '') {
      TablaComunService.getAsSelect(TiposTablaComunConstant.PROVINCIA, {
        idDepartamento: idDepartamento
      })
        .then(({ data }) => setProvincias(data))
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }, [__zariContext, idDepartamento])

  return (
    <Form.Group>
      <Form.Label text='PROVINCIA' htmlFor='select-idProvincia' md={2} />
      <Col md={10}>
        <Field name='_idProvincia'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-idProvincia'
              onChange={e => {
                handleChange(e)
                values._idProvincia = e.target.value
                values._idDistrito = ''
                setValues(values)
              }}
            >
              <option value=''>Seleccionar</option>
              {provincias.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdProvinciaFormGroup)
